import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { Types } from "../actions/templateActions";

const templateReducers = (state, action) => {
	switch (action.type) {
		case Types.TEMPLATES_ADD: {
			let newState = _.cloneDeep(state);

			newState.advisors.settings.templates =
				(newState.advisors.settings.templates && [...newState.advisors.settings.templates]) || [];

			newState.advisors?.settings?.templates?.push({
				id: uuidv4(),
			});

			return newState;
		}
		case Types.TEMPLATES_UPDATE_FIELD: {
			let newState = _.cloneDeep(state);

			newState.advisors.settings.templates.find((item) => item.id == action.id)[action.field] = action.newValue;

			return newState;
		}

		default:
			return state;
	}
};

export default templateReducers;
